/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Overview/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DefaultPaymentPlans from './DefaultPaymentPlans/index'
import PlanRules from './PlanRules/index'
import PlanSteps from './PlanSteps/index'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'



/** @type {import('Simple/types.js').View} */
export default function Overview({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/Overview"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Overview.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<PlanRules
  viewPath={`${viewPath}/PlanRules`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<PlanSteps
  viewPath={`${viewPath}/PlanSteps`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<DefaultPaymentPlans
  viewPath={`${viewPath}/DefaultPaymentPlans`}
/>
</div>
{children}
</React.Fragment>)
}